/**
 * Perlehaus "Write a Review" form.
 *
 * Frontend-only: validates input, shows submit/success/error states, and
 * POSTs a JSON payload to PerlehausWriteReview.endpoint. Nothing is ever
 * written to localStorage, sessionStorage, or any Shopify data store from
 * here -- the only persistence is whatever the receiving endpoint does
 * with the email it sends, which is outside this file entirely.
 */
(function () {
  'use strict';

  // Not yet deployed -- see the documented backend requirement. Until a
  // real endpoint exists here, submission will correctly show the error
  // state rather than silently pretending to succeed.
  var ENDPOINT = '';

  var MAX_FILE_BYTES = 8 * 1024 * 1024; // 8MB

  function initForm(form) {
    var starPicker = form.querySelector('[data-star-picker]');
    var fileInput = form.querySelector('.perlehaus-write-review__file-input');
    var uploadFilename = form.querySelector('[data-upload-filename]');
    var uploadDropzone = form.querySelector('[data-upload-dropzone]');
    var statusEl = form.querySelector('[data-form-status]');
    var submitBtn = form.querySelector('[data-submit-review]');
    var submitLabel = submitBtn.querySelector('[data-submit-label]');
    var cancelBtn = form.querySelector('[data-cancel-review]');

    function clearErrors() {
      var errs = form.querySelectorAll('.perlehaus-write-review__error');
      for (var i = 0; i < errs.length; i++) errs[i].hidden = true;
      form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
        el.removeAttribute('aria-invalid');
      });
    }

    function showError(name) {
      var el = form.querySelector('[data-error-for="' + name + '"]');
      if (el) el.hidden = false;
      var field = form.querySelector('[name="' + name + '"]');
      if (field) field.setAttribute('aria-invalid', 'true');
    }

    function setStatus(message, kind) {
      statusEl.hidden = !message;
      statusEl.textContent = message || '';
      statusEl.className = 'perlehaus-write-review__status' + (kind ? ' perlehaus-write-review__status--' + kind : '');
    }

    function setSubmitting(isSubmitting) {
      submitBtn.disabled = isSubmitting;
      cancelBtn.disabled = isSubmitting;
      submitLabel.textContent = isSubmitting ? 'Submitting…' : 'Submit Review';
    }

    // File upload: show the chosen filename, enforce a size ceiling
    // client-side (the real limit is still enforced server-side by
    // whatever endpoint receives this).
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      var errEl = form.querySelector('[data-error-for="reviewMedia"]');
      errEl.hidden = true;
      if (!file) {
        uploadFilename.textContent = 'Click to upload a photo or video';
        return;
      }
      if (file.size > MAX_FILE_BYTES) {
        errEl.hidden = false;
        fileInput.value = '';
        uploadFilename.textContent = 'Click to upload a photo or video';
        return;
      }
      uploadFilename.textContent = file.name;
    });

    uploadDropzone.addEventListener('click', function (e) {
      if (e.target !== fileInput) fileInput.click();
    });

    // Star rating: click-to-select already works natively via the radio
    // inputs. This only adds a live hover preview, matching normal
    // review-widget conventions -- purely cosmetic, not required for
    // the control to function (keyboard users get the native radio
    // group behavior: arrow keys move selection, space/click selects).
    var starLabels = starPicker.querySelectorAll('.perlehaus-write-review__star-label');
    starLabels.forEach(function (label) {
      label.addEventListener('mouseenter', function () {
        starPicker.classList.add('is-previewing');
        label.parentElement; // no-op, CSS handles preview via :hover ~ sibling selectors
      });
    });
    starPicker.addEventListener('mouseleave', function () {
      starPicker.classList.remove('is-previewing');
    });

    form.addEventListener('reset', function () {
      clearErrors();
      setStatus('', null);
      uploadFilename.textContent = 'Click to upload a photo or video';
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErrors();
      setStatus('', null);

      var rating = form.querySelector('input[name="rating"]:checked');
      var reviewTitle = form.querySelector('[name="reviewTitle"]');
      var reviewContent = form.querySelector('[name="reviewContent"]');
      var displayName = form.querySelector('[name="displayName"]');
      var email = form.querySelector('[name="email"]');

      var valid = true;
      if (!rating) { showError('rating'); valid = false; }
      if (!reviewTitle.value.trim()) { showError('reviewTitle'); valid = false; }
      if (!reviewContent.value.trim()) { showError('reviewContent'); valid = false; }
      if (!displayName.value.trim()) { showError('displayName'); valid = false; }
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email.value.trim() || !emailPattern.test(email.value.trim())) { showError('email'); valid = false; }

      if (!valid) {
        setStatus('Please fix the highlighted fields before submitting.', 'error');
        return;
      }

      if (!ENDPOINT) {
        setStatus('Review submission isn’t connected yet — this form is still in preview.', 'error');
        return;
      }

      setSubmitting(true);

      var payload = new FormData();
      payload.append('rating', rating.value);
      payload.append('reviewTitle', reviewTitle.value.trim());
      payload.append('reviewContent', reviewContent.value.trim());
      payload.append('displayName', displayName.value.trim());
      payload.append('email', email.value.trim());
      payload.append('productTitle', form.dataset.productTitle || '');
      payload.append('productUrl', location.origin + (form.dataset.productUrl || ''));
      payload.append('submittedAt', new Date().toISOString());
      if (fileInput.files && fileInput.files[0]) {
        payload.append('media', fileInput.files[0]);
      }

      fetch(ENDPOINT, { method: 'POST', body: payload })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed');
          return res.json().catch(function () { return {}; });
        })
        .then(function () {
          setSubmitting(false);
          form.reset();
          uploadFilename.textContent = 'Click to upload a photo or video';
          setStatus('Thank you — your review has been sent to our team.', 'success');
        })
        .catch(function () {
          setSubmitting(false);
          setStatus('Something went wrong sending your review. Please try again shortly.', 'error');
        });
    });
  }

  document.querySelectorAll('.perlehaus-write-review').forEach(initForm);
})();
